var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('Navbar',{staticClass:"py-0",on:{"drawerCtrl":_vm.drawerCtrl}}),_c('Sidebar',{attrs:{"drawer":_vm.drawer},on:{"update:drawer":function($event){_vm.drawer=$event}}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }